var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "alert-flex alert-position",
      class: _vm.alertPosition(_vm.position),
    },
    _vm._l(_vm.alerts, function (alert, index) {
      return _c(
        "div",
        {
          key: index,
          class: [
            _vm.alertType(alert.type),
            {
              "alert-has-close": alert.hasClose,
              "alert-fade": alert.hasAnimation,
              "alert-fade-in": alert.hasAnimation && !alert.isAnimationDone,
            },
          ],
        },
        [
          alert.hasClose
            ? _c("div", { staticClass: "i-alert-close" }, [
                _c(
                  "a",
                  {
                    attrs: { role: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.preDeleteAlert(alert)
                      },
                    },
                  },
                  [_c("icon", { staticClass: "icon-close-info-br" })],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          alert.title
            ? _c("h2", [
                _vm._v("\n      " + _vm._s(_vm.$t(alert.title)) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          alert.text
            ? _c("p", { staticClass: "i-alert-text" }, [
                _vm._v("\n      " + _vm._s(_vm.$t(alert.text)) + "\n    "),
              ])
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }